// project hash key
// e921d896b24ee51ad95dc303a034758da1187532b0a44189bd99aa333255781b

import React from 'react';

function PriceItemArea({ title, value, className, valueTax }) {
  return (
    <div className="price-info">
      <div className="title NotoSansJP500">
        <span>{title}</span>
      </div>
      <div className={`show-value ${className}`}>
        {value} <span className="price-info-tax">{valueTax}</span>
      </div>
    </div>
  );
}

export default PriceItemArea;
